import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export default function ModalConfirmacion({
    open,
    onClose,
    onConfirm,
    campana,
}) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [minDate, setMinDate] = useState(null);

    useEffect(() => {
        setMinDate(
            campana?.fecha_ultimo_cierre
                ? dayjs(campana?.fecha_ultimo_cierre)
                      .startOf('isoWeek')
                      .add(1, 'week')
                : dayjs().subtract(1, 'week').startOf('isoWeek'),
        );
    }, [campana?.fecha_ultimo_cierre]);

    const handleConfirm = () => {
        onConfirm(selectedDate);
        onClose();
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
                <DialogTitle>Seleccionar fecha</DialogTitle>
                <DialogContent>
                    <DatePicker
                        label="Fecha"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} fullWidth />
                        )}
                        displayWeekNumber
                        disableFuture
                        showDaysOutsideCurrentMonth
                        minDate={minDate}
                        sx={{ marginTop: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        disabled={!selectedDate}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}
